<template>
	<div style="padding:5px;background:var(--grey-2);margin-top:5px;">
		<b style="padding-left:0px;color:var(--grey-6);">{{ this.label}}</b>
		<div style="max-height:150px;overflow:scroll;margin-top:10px;">
			<div style="">
				<SearchCategoryRow v-for="(category, index) in this.categoryList" :categoryId="category.categoryId"
					:key="category.categoryId + '_' + index" :productCount="this.prouductCountLabel(category)" @searchCategorySelected="((category) => {
						this.$emit('searchCategorySelected', category)
					})" />
			</div>
		</div>
	</div>
</template>
<script>
import listHelper from '@/helper/list-helper';
import { STORE_GETTER } from '@/store/store';
import SearchCategoryRow from './SearchCategoryRow.vue';

import { routerMixin } from "@/mixins/routerMixin.js";
import { categoryMixin } from "@/mixins/categoryMixin.js";

//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SearchCategoryView",
	components: { SearchCategoryRow },
	mixins: [routerMixin, categoryMixin ],
	data() {
		return {
			category: null

		};
	},
	computed: {

		/*categoryList() {

			if (this.baseModel && this.baseModel.categoryModel && this.baseModel.categoryModel.categoryList) {

				if (this.searchProductConfig && this.searchProductConfig.searchPhrase && this.searchProductConfig.searchPhrase.length > 1) {

					return listHelper.filterList(this.baseModel.categoryModel.categoryList, this.searchProductConfig.searchPhrase);

				} else {

					return this.baseModel.categoryModel.categoryList
				}

			}
			return null;

		},*/

		prouductCountList(){

			const productCountList = this.$store.getters[STORE_GETTER.CATEGORY_PRODUCT_COUNT_LIST];


			//console.log('FP: productCountList: ', productCountList);
			

			return productCountList;
		},

		categoryList() {

			const categoryModel = this.$store.getters[STORE_GETTER.CATEGORY_MODEL];



			if (categoryModel && categoryModel.categoryList) {

				var categoryList = [];

				if (this.searchProductConfig && this.searchProductConfig.searchPhrase && this.searchProductConfig.searchPhrase.length > 1) {

					categoryList = listHelper.filterList(categoryModel.categoryList, this.searchProductConfig.searchPhrase);

				} else {

					categoryList = categoryModel.categoryList
				}

				return categoryList.filter(category => category.id > 0); // rensa bort huvud-kategorierna 

			}
			return null;

		},

		searchProductConfig() {

			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},

		baseModel() {
			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];
			return baseModel;
		},

		label() {

			if (!this.categoryList || this.categoryList?.length == 0) {
				return "Hittade inga kategorier"
			}

			if (this.isOnProductListPage()) {
				return "Filtrera resultat på kategori"
			} else {
				return "Visa allt i kategori"
			}
		}



	},
	watch: {
		category: function (category) {
			console.log("FP: watcher: ", category);
		}
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}
	},
	methods: {

		prouductCountLabel(category){

			const count = this.prouductCountList[category.categoryId];

			if (count && count > 0){
				return count + ""
			}

			return "--";

		},

		

	},
	created() {

	}
};
</script>

<style scoped></style>